import { render, staticRenderFns } from "./MSExchangeSettings.vue?vue&type=template&id=029bb9ac&scoped=true&lang=pug&"
import script from "./MSExchangeSettings.vue?vue&type=script&lang=js&"
export * from "./MSExchangeSettings.vue?vue&type=script&lang=js&"
import style0 from "./MSExchangeSettings.vue?vue&type=style&index=0&id=029bb9ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029bb9ac",
  null
  
)

export default component.exports